import CardViewComponent from '../../lib/CardViewComponent/CardViewComponent';
import {SPAIN_COUNTRY_CODE, SPAIN_WARRANTY_ASSET} from '../../utils/constant';

import {
  Modal,
  ModalContent,
  ModalContentText,
  ModalTitle,
  Typography,
} from '@deere/fuel-react';
import proptypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import './EquipmentViewPopup.css';

const EquipmentViewPopup = (props) => {
  const {t} = useTranslation();
  const [assetsDetails, setAssetsDetails] = React.useState([]);

  const handleClose = () => {
    props.setVisible(false);
  };

  React.useEffect(() => {
    let assetsTemp;
    if (props.selectedContractNumber && props.contractDetails) {
      let assetsArray =
        props.docType === 'LIEN_DE_REGISTRATION_LETTERS'
          ? props.lienDeregistrationData?.[props.selectedContractNumber]?.assets
          : props.contractDetails[props.selectedContractNumber]?.assets;
      let item;
      if (props.countryCode === SPAIN_COUNTRY_CODE) {
        assetsTemp = assetsArray
          ?.filter(
            (asset) =>
              asset?.model?.modelName.toLowerCase() !== SPAIN_WARRANTY_ASSET
          )
          ?.map((asset) => {
            item = {
              SERIAL_NUMBER: {
                label: t('SERIAL_NUMBER'),
                value: asset.serialNumber ?? 'NA',
              },
              REGISTRATION_NUMBER: {
                label: t('REGISTRATION_NUMBER'),
                value: asset.registrationNumber ?? 'NA',
              },
            };
            return item;
          });
      } else {
        assetsTemp = assetsArray?.map((asset) => {
          item = {
            MODEL_NUMBER: {
              label: t('MODEL_NUMBER'),
              value: asset.description ?? 'NA',
            },
            SERIAL_NUMBER: {
              label: t('SERIAL_NUMBER'),
              value: asset.serialNumber ?? 'NA',
            },
            REGISTRATION_NUMBER: {
              label: t('REGISTRATION_NUMBER'),
              value: asset.registrationNumber ?? 'NA',
            },
          };
          return item;
        });
      }
      setAssetsDetails(assetsTemp);
    }
  }, [props.selectedContractNumber, props.contractDetails]);

  const headers =
    assetsDetails?.length > 0 ? Object.keys(assetsDetails[0]) : [];

  return (
    <Modal
      className="EquipmentViewPopup"
      open={props.visible}
      onClose={handleClose}
      aria-labelledby="alert-Modal-title"
      aria-describedby="alert-Modal-description"
      fullWidth={true}
    >
      <ModalTitle bgcolor={'#F0F0F0'} id={'alert-Modal-title'}>
        {props.title}
      </ModalTitle>
      <ModalContent>
        <ModalContentText id="alert-Modal-description">
          <div className="assetPopupContainer">
            <div className="assetPopupHeader">
              {headers.map((item) => (
                <Typography key={item}>{t(item)}</Typography>
              ))}
            </div>
            <div className="">
              {assetsDetails?.map((item, index) => (
                <div
                  className="assetPopupBody"
                  key={'assets-component' + Object.values(item)}
                >
                  {Object.values(item).map((i) => (
                    <Typography variant="label" key={i.value}>
                      {i.value}
                    </Typography>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <div className="assetPopupContainerMobileView">
            {assetsDetails &&
              assetsDetails.length > 0 &&
              assetsDetails.map((asset, index) => (
                <CardViewComponent
                  key={'card-component'}
                  records={asset}
                  className={'contractDetailSection'}
                />
              ))}
          </div>
        </ModalContentText>
      </ModalContent>
    </Modal>
  );
};

EquipmentViewPopup.propTypes = {
  setVisible: proptypes.func,
  selectedContractNumber: proptypes.string,
  docType: proptypes.string,
  visible: proptypes.bool,
  title: proptypes.string,
  contractDetails: proptypes.object,
  countryCode: proptypes.string,
  lienDeregistrationData: proptypes.object,
};

export const mapStateToProps = (state) => {
  return {
    contractDetails: state.appStates.contractDetails?.accountDetails,
    countryCode: state.appStates.allContracts?.countryCode,
    lienDeregistrationData: state.appStates.lienDeregistrationData,
  };
};
export default connect(mapStateToProps)(EquipmentViewPopup);
